import React, { useState, useEffect, useRef } from 'react';
import styles from '../CSS/AgentHome.module.css';

import { GiCheckMark } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";


import { GoArrowRight } from "react-icons/go";

import { useAuth } from '../AuthContext';

import Loading from '../Components/Loading';
import Error from '../Components/Error';
import { useNavigate } from 'react-router-dom';

const Payouts = () => {
    const { fetchData, postData } = useAuth();
    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [list, setList] = useState([]);
    const [payouts, setPayouts] = useState({
        inInr: 0,
        inCrypto: 0,
        no: 0
    });


    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    const isFirstRun = useRef(true);
    async function getData() {
        setLoader(true);

        try {
            const data = await fetchData('/admin/pending/payments');
            setLoader(false);

            setPayouts({
                no: data.no,
                inInr: data.crypto,
                inCrypto: data.crypto
            })

            setList(data.records || []);

        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        if (isFirstRun.current) {
            getData();
            isFirstRun.current = false;
        }
    }, [])

    async function payAction(action, orderId) {
        setLoader(true);

        try {
            await postData('/admin/callback/withdraw/crypto', { action, orderId });
            setLoader(false);

            setList(prevData => prevData.filter(item => item.orderId !== orderId));
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    return (
        <div className='dashboard'>
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Pending Withdrawals</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="records-top">
                <div className="asset-details">
                    <div className="sec-col">
                        <div className="sec-col-top">{payouts.no}</div>
                        <div className="sec-col-bottom">Payouts No.</div>
                    </div>
                    <div className="sec-col">
                        <div className="sec-col-top">${parseFloat((payouts?.inCrypto)?.toFixed(0)).toLocaleString()}</div>
                        <div className="sec-col-bottom">Total Payouts</div>
                    </div>
                    <div className="sec-col">
                        <div className="sec-col-top">${parseFloat((payouts?.inInr).toFixed(0))?.toLocaleString()}</div>
                        <div className="sec-col-bottom">Total Tax</div>
                    </div>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Withdrawal Amount</th>
                            <th>Details</th>
                            <th>Recharges</th>
                            <th>Withdrawals</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((w, i) => (
                            <tr key={i}>
                                <td>
                                    <div>{w.orderId}</div>
                                    <div className="subtext">{w.date}</div>
                                </td>
                                <td>
                                    <div>${w.amount * 0.93} USD</div>
                                    <div className="subtext">Account Id: {w.id}</div>
                                </td>
                                <td>
                                    <div>{w.details?.address}</div>
                                    <div className="subtext">Method: {w.details?.method}</div>
                                </td>
                                <td>
                                    <div>${w.recharges}</div>
                                </td>
                                <td>
                                    <div>${w.payouts}</div>
                                </td>
                                <td>
                                    <button className="btn approve" onClick={() => payAction('approve', w.orderId)}>Approve</button>
                                    <button className="btn decline" onClick={() => payAction('reject', w.orderId)}>Decline</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Payouts